'use client';

import { c as _c } from "react/compiler-runtime";
import { publishEvent, TrackImpression } from '@udemy-v2/event-tracking';
import { useFormatDate, useI18n } from '@udemy-v2/i18n';
import { AlertBanner } from '@udemy-v2/react-notice-components';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { CourseRetirementBannerImpressionEvent } from '@/features/course-landing-page/events/events';
import { useCourseRetirement } from '@/features/course-landing-page/hooks/use-course-retirement';
import styles from './course-retirement-banner.module.scss';
export const CourseRetirementBanner = () => {
  const $ = _c(18);
  const {
    gettext,
    interpolate
  } = useI18n();
  const {
    toLocaleDateString
  } = useFormatDate();
  const course = useClpCourse();
  const {
    retiresOn
  } = useCourseRetirement(course.id);
  if (!retiresOn) {
    return null;
  }
  let t0;
  if ($[0] !== gettext || $[1] !== interpolate || $[2] !== retiresOn || $[3] !== toLocaleDateString) {
    const formattedRetirementDate = toLocaleDateString(new Date(retiresOn), {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
    t0 = interpolate(gettext("This course is set to be retired from your organization\u2019s content collection on %(retirementDate)s."), {
      retirementDate: formattedRetirementDate
    }, true);
    $[0] = gettext;
    $[1] = interpolate;
    $[2] = retiresOn;
    $[3] = toLocaleDateString;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const title = t0;
  let t1;
  if ($[5] !== course.frontendTrackingId || $[6] !== course.id) {
    t1 = () => {
      publishEvent(new CourseRetirementBannerImpressionEvent({
        courseId: Number(course.id),
        courseTrackingId: course.frontendTrackingId ?? ""
      }));
    };
    $[5] = course.frontendTrackingId;
    $[6] = course.id;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleImpression = t1;
  let t2;
  if ($[8] !== gettext) {
    t2 = gettext("We're always updating our content collection to keep it fresh but enrolled learners won't lose access to this course.");
    $[8] = gettext;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <p>{t2}</p>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t3 || $[13] !== title) {
    t4 = <AlertBanner className={styles.container} data-testid="course-retirement-banner" udStyle="warning" title={title} showCta={false} body={t3} />;
    $[12] = t3;
    $[13] = title;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== handleImpression || $[16] !== t4) {
    t5 = <TrackImpression trackFunc={handleImpression} testId="course-retirement-banner-impression">{t4}</TrackImpression>;
    $[15] = handleImpression;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};